"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactRedux = require("react-redux");

var _prospectingContacts = require("../../../../constants/prospectingContacts.schemas");

var _sendAs = require("../../../../../../../CreateGift/store/send-as/send-as.selector");

var _user = require("../../../../../../../Shared/store/user/user.selectors");

var _StyledFieldSkeleton = require("./StyledFieldSkeleton");

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      zIndex = _ref.zIndex;
  return {
    helperText: {
      margin: 0
    },
    popper: {
      zIndex: zIndex.modal,
      minWidth: 220,
      maxWidth: 220
    },
    countryValueLabel: {
      color: palette.text.primary
    }
  };
});

var SendAsCell = function SendAsCell(_ref2) {
  var rowIndex = _ref2.rowIndex,
      columnData = _ref2.columnData,
      rowData = _ref2.rowData;
  var classes = useStyles();
  var name = "".concat(_prospectingContacts.ContactStepField.contacts, ".").concat(rowIndex, ".").concat(_prospectingContacts.ContactField.sendAsEmail);
  var currentUserId = (0, _reactRedux.useSelector)(_user.getUserId);
  var users = (0, _reactRedux.useSelector)(_sendAs.getSendAsList);
  var isUsersLoading = (0, _reactRedux.useSelector)(_sendAs.getSendAsIsLoading);

  var _useController = (0, _reactHookForm.useController)({
    control: columnData === null || columnData === void 0 ? void 0 : columnData.control,
    name
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var onSendAsChange = (0, _react.useCallback)(function (_ref3) {
    var target = _ref3.target;
    onChange(target.value);
  }, [onChange]);
  var hasError = Boolean(error === null || error === void 0 ? void 0 : error.message);
  return rowData !== null && rowData !== void 0 && rowData.id ? /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    error: hasError,
    fullWidth: true,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
    id: "gift-message-select-send-as-label"
  }, "Send this message as"), /*#__PURE__*/_react.default.createElement(_material.Select, {
    label: "Send this message as",
    labelId: "gift-message-select-send-as-label",
    disabled: isUsersLoading,
    value: value,
    onChange: onSendAsChange
  }, users.map(function (user) {
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: user.id,
      value: user.email
    }, user.id === currentUserId ? "Myself (".concat(user.first_name, " ").concat(user.last_name, ")") : "".concat(user.first_name, " ").concat(user.last_name));
  })), hasError && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
    classes: {
      contained: classes.helperText
    }
  }, error === null || error === void 0 ? void 0 : error.message)) : /*#__PURE__*/_react.default.createElement(_StyledFieldSkeleton.StyledFieldSkeleton, {
    variant: "rect",
    width: "100%",
    height: 48
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(SendAsCell);

exports.default = _default;